import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useGetLcrWorksheet = (crId, lcrId, worksheetId) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  return useQuery(
    ['lcrWorksheet', crId, lcrId, worksheetId],
    () => axiosInstance.get(liveCleanroom(orgId)
      .getLcrWorksheet(crId, lcrId, worksheetId)),
    {
      enabled: !!worksheetId,
      select: (response) => response.data?.liveCleanRoomWorksheet,
      onError: (error) => {
        dispatch(showAlert({
          message: error.response?.data?.message || 'Error fetching LCR worksheet',
          type: 'error',
        }));
      },
    },
  );
};
